<template>
	<transition name="modal">
		<div class="modal-mask" :id="this.id" v-if="isActive">
			<div class="modal-wrapper">
				<div class="modal-container" :class="'modal-container--'+size">
					<button @click="$emit('close')" class="modal-close-small">×</button>
					<!--<div class="modal-header">
						<slot name="header" >

						</slot>
					</div>-->

					<div class="modal-body">
						<slot name="body">

						</slot>
					</div>

					<div class="modal__footer">
						<slot name="footer">

						</slot>
					</div>
				</div>
			</div>
		</div>
	</transition>

</template>
<script>

	export default {
		name: 'modal',
		props: {
			size: {
				type: String,
				default: ''
			}
		},
		data(){
			return{
				id: ''
			}
		},
		computed:{
			isActive(){
				return this.isModalLastActive(this.id);
			}
		},
		beforeDestroy(){
			document.querySelector('body').classList.remove('body--modal-open');
			this.removeModal(this.id);
		},
		mounted(){
			this.id = 'modal__'+this.localRandomString();
			this.addModal(this.id);
			document.querySelector('body').classList.add('body--modal-open');
		}
	}
</script>
<style lang="scss">

	.modal-mask {
		position: fixed;
		z-index: 5998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		max-width: 100%;
		background-color: rgba(0, 0, 0, .5);
		transition: opacity .3s ease;

		display: flex;
		align-items: center;
		justify-content: center;
		overflow-y: auto;
	}

	.modal-wrapper {

		position: absolute;
		top: 0;
		max-width: 100%;
		min-height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.modal-container {
		position: relative;
		width: 1150px;
		max-width: 100%;
		margin: 35px auto;
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
		transition: all .3s ease;
		color: #464b4e;
		font-size: 18px;
		font-weight: 600;
		@media (min-width: 1150px) {
			padding: 50px 110px;
		}
		h2{
			margin-top: 0;
			color: black;
			font-size: 33px;
			font-weight: bold;
			margin-bottom: 85px;
		}

		&--sm{
			width: 640px;
			padding: 50px 40px;
		}
		&--md{
			width: 768px;
			padding: 50px 40px;
			@media (max-width: 1150px){
				padding: 30px 20px;
			}
		}

	}

	.modal-close-small{
		position: absolute;
		top: 7px;
		//opacity: 0;
		right: 7px;
		padding: 0;
		margin: 0;
		width: 30px;
		height: 30px;
		font: 37px/1 Arial,Helvetica Neue,Helvetica,sans-serif;
		color: #000;
		font-weight: 300;
		text-align: center;
		border-radius: 50%;
		border-width: 0;
		cursor: pointer;
		background: transparent;
		transition: background .2s;
		box-sizing: border-box;
		z-index: 2;
		@media (min-width: 1150px) {
			right: 20px;
			top: 20px;
		}

		&:hover{
			opacity: 0.5;
		}
	}

	.modal-header h3 {
		margin-top: 0;
		color: #42b983;
	}
	.modal__footer{
		border-top: none;
	}

	.modal-body {
		margin: 20px 0;
	}

	.modal-default-button {
		float: right;
	}

	/*
	 * The following styles are auto-applied to elements with
	 * transition="modal" when their visibility is toggled
	 * by Vue.js.
	 *
	 * You can easily play with the modal transition by editing
	 * these styles.
	 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

</style>